import React from 'react';
import style from '../css/TrustCompany.module.css';

const companies = [
	{
		name: 'Google',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
	},
	{
		name: 'Microsoft',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg',
	},
	{
		name: 'Apple',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg',
	},
	{
		name: 'Amazon',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
	},
	{
		name: 'Facebook',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png',
	},
	{
		name: 'IBM',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg',
	},
	{
		name: 'Intel',
	},
	{
		name: 'Cisco',
	},
	{
		name: 'Oracle',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/5/50/Oracle_logo.svg',
	},
	{
		name: 'SAP',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg',
	},
	{
		name: 'Adobe',
	},
	{
		name: 'Salesforce',
	},
	{
		name: 'NVIDIA',
	},
	{
		name: 'Dell',
		logo: 'https://upload.wikimedia.org/wikipedia/commons/4/48/Dell_Logo.svg',
	},
	{
		name: 'HP',
	},
];

function TrustCompany() {
	return (
		<div className={style.component}>
			<div className={style.textComponent}>
				<div className={style.line} />
				<h1 className={style.title}>Trust Company</h1>
				<div className={style.line} />
			</div>

			<div className={style.scrollContainer}>
				<div className={style.scrollContent}>
					{[...companies, ...companies].map((company, index) => (
						<div className={style.companyItem} key={index}>
							{company.logo ? (
								<img
									src={company.logo}
									alt={company.name}
									className={style.logo}
								/>
							) : null}
							<span className={style.companyName}>{company.name}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default TrustCompany;
